import { addWeeks, getDay, format, startOfWeek } from "date-fns";
const scheduler = window.scheduler;

export function copyWeek() {
  const weekStart = startOfWeek(scheduler.getState().min_date, { weekStartsOn: 1 })
  const weekEnd = addWeeks(weekStart, 1)
  const eventsInView = scheduler.getEvents(weekStart, weekEnd);
  // transform events in view to match payload schema
  const AvailabilityTemplateItems = []
  eventsInView.forEach((event) => {
    let DayNumber = (getDay(event.start_date) + 6) % 7
    let AvailabilityType = event.eventType[0]
    let eventPayload = {
      DayNumber,
      StartTime: format(event.start_date, "HH:mm"),
      EndTime: format(event.end_date, "HH:mm"),
      AvailabilityType
    }
    AvailabilityTemplateItems.push(eventPayload)
  })
  return AvailabilityTemplateItems
}